var map = {
	"./Data protection-emcomy-desktop.webp": 87709,
	"./Data protection-emcomy.webp": 56419,
	"./Imprint-emcomy-desktop.webp": 79626,
	"./Imprint-emcomy.webp": 39826,
	"./Terms of use-emcomy-desktop.webp": 5075,
	"./Terms of use-emcomy.webp": 50348,
	"./de.webp": 20542,
	"./dead_DE.webp": 73581,
	"./dead_EN.webp": 10227,
	"./dead_ES.webp": 88455,
	"./dead_PT.webp": 23235,
	"./dead_PTBR.webp": 69193,
	"./emcomyLogo-pt.webp": 13513,
	"./emcomyLogoWhite.webp": 42083,
	"./emcomyLogoWhiteCut.webp": 88658,
	"./en.webp": 81580,
	"./es.webp": 89659,
	"./green-wave.webp": 7251,
	"./halfPTBR.webp": 78322,
	"./hospital_DE.webp": 88798,
	"./hospital_EN.webp": 83450,
	"./hospital_ES.webp": 87279,
	"./hospital_PT.webp": 63465,
	"./hospital_PTBR.webp": 75640,
	"./private-message-icons/private-message-01.webp": 36074,
	"./private-message-icons/private-message-02.webp": 26903,
	"./private-message-icons/private-message-03.webp": 43089,
	"./private-message-icons/private-message-04.webp": 33187,
	"./pt.webp": 44282,
	"./ptBR.webp": 71707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97226;